import { GovernancePolicyFlags } from '@agilelab/plugin-wb-governance-common';

export const selectOnViolationSeverity = <T>(
  counts: GovernancePolicyFlags,
  options: { [key in keyof GovernancePolicyFlags]: T },
  fallback: T,
) => {
  if (counts.error > 0) {
    return options.error;
  } else if (counts.warning > 0) {
    return options.warning;
  } else if (counts.info > 0) {
    return options.info;
  }
  return fallback;
};
